import { Component } from '@angular/core';

@Component({
  selector: 'app-features-style-two',
  standalone: false,
  templateUrl: './features-style-two.component.html',
  styleUrl: './features-style-two.component.scss'
})
export class FeaturesStyleTwoComponent {

}
